import { Component } from '@poa/core';
import React from 'react';
import Select from 'react-select';
import ChatSidebarContent from './sidebar_content';
import { observable } from '@poa/state';


class ChatsSidebar extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    t; // injected by Poa

    constructor(props) {
        super(props);
        this.onPanelChange = this.onPanelChange.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
        this.localSearchState = observable({status: 'active'});
    }

    getFilerBy = (panel) => {
        return {
            'all': '',
            'index': '',
            'account_id': '',
            'name': '',
            'panels': [panel],
            'managers': [],
            'teamleads': [],
            'scouts': [],
            'operators': [],
            'account-managers': [],
            'levels': [],
            'nick': '',
            'email': ''
        }
    }

    credsList() {
        return this.store.chats.cred_list.map((item) => {
            return { value: item.id, label: item.title }
        });
    }

    onPanelChange(value) {
        this.store.chats.selected_cred_id = value;
        this.actions.chatsActions.refreshAccounts(
            this.getFilerBy(value.label),
            1,
            null,
            null,
            200,
            this.localSearchState.status === 'все' ? null : this.localSearchState.status
        );
    }

    onStatusChange(value) {
        this.localSearchState.status = value.value;
        this.actions.chatsActions.refreshAccounts(
            this.getFilerBy(this.store.chats.selected_cred_id.label),
            1,
            null,
            null,
            200,
            value.value === 'все' ? null : this.localSearchState.status
        );
    }

    render() {
        return (
            <>
                <div className='general-page__container-sidebar'>
                    <div className='general_sidebar-header' style={{ overflowY: 'visible' }}>
                        <div className='general_sidebar-header__search'>
                            <div className='search__input input'>
                                <Select
                                    style={{ zIndex: 1000 }}
                                    searchable={true}
                                    name='form-field-name'
                                    disabled={false}
                                    value={this.store.chats.selected_cred_id ? this.store.chats.selected_cred_id : ""}
                                    isLoading={false}
                                    onChange={this.onPanelChange}
                                    options={this.credsList()}
                                    clearable={false}
                                    noResultsText={this.t('noResults')}
                                />
                            </div>
                        </div>
                        <div className='general_sidebar-header__search'>
                            <div className='search__input input'>
                                <Select
                                    style={{ zIndex: 1000 }}
                                    searchable={true}
                                    name='form-field-name'
                                    disabled={false}
                                    value={this.localSearchState.status}
                                    isLoading={false}
                                    onChange={this.onStatusChange}
                                    clearable={false}
                                    noResultsText={this.t('noResults')}
                                    options={[
                                        { value: 'все', label: 'все' },
                                        { value: 'active', label: 'active' },
                                        { value: 'inactive', label: 'inactive' },
                                        { value: 'rejected', label: 'rejected' },
                                        { value: 'suspended', label: 'suspended' },
                                        { value: 'blocked', label: 'blocked' },
                                        { value: 'deleted', label: 'deleted' },
                                        { value: 'transferred', label: 'transferred' },
                                        { value: 'transfered', label: 'transfered' },
                                        { value: 'on verification', label: 'on verification' }
                                      ]}
                                />
                            </div>
                        </div>
                    </div>
                    <ChatSidebarContent />
                </div>

            </>
        );
    }
}

export default Component({ namespaces: ['chats-sidebar'] })(ChatsSidebar);
